import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CREDENCIADOS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterAnexos(codContratacao) {
        return axiosJwt
            .get(`${api}/credenciados/contratacoes/${codContratacao}/anexos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexosTipos(codContratacao) {
        return axiosJwt
            .get(
                `${api}/credenciados/contratacoes/${codContratacao}/anexos/tipos`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirAnexo(anexo) {
        const formData = new FormData()
        formData.append('codContratacao', anexo.codContratacao)
        formData.append('tipoId', anexo.tipoId)
        formData.append('descritivo', anexo.descritivo)
        formData.append('arquivo', anexo.arquivo)

        return axiosJwt
            .post(
                `${api}/credenciados/contratacoes/${anexo.codContratacao}/anexos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAnexo(codContratacao, anexoId) {
        return axiosJwt
            .delete(
                `${api}/credenciados/contratacoes/${codContratacao}/anexos/${anexoId}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexo(codContratacao, anexoId) {
        return axiosJwt
            .get(
                `${api}/credenciados/contratacoes/${codContratacao}/anexos/${anexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
